// import Swiper from 'swiper/bundle';
// import 'swiper/css/bundle';

// document.addEventListener('DOMContentLoaded', () => {
//     document.querySelectorAll('.products-slider').forEach((section) => {
//         const sliderContainer = section.querySelector('.ps-slider');
//         if (!sliderContainer) { return; }


//         new Swiper(sliderContainer, {
//             slidesPerView: 1,
//             slidesPerGroup: 1,
//             spaceBetween: 20,
//             loop: false,
//             speed: 800,
//             pagination: {
//                 el: section.querySelector('.ps-pagination'),
//                 clickable: true,
//             },
//             breakpoints: {
//                 660: {
//                     slidesPerView: 2,
//                     slidesPerGroup: 1,
//                     spaceBetween: 16,
//                 },
//                 767: {
//                     slidesPerView: 2,
//                     slidesPerGroup: 1,
//                     spaceBetween: 20,
//                 },
//                 1024: {
//                     slidesPerView: 3,
//                     slidesPerGroup: 1,
//                     spaceBetween: 20,
//                 },
//                 1200: {
//                     slidesPerView: 3,
//                     slidesPerGroup: 1,
//                     spaceBetween: 50,
//                 },
//             },
//         });
//     });
// });


import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

document.addEventListener('DOMContentLoaded', () => {

    // 👉 function for equal height
    function setPsTitleHeight(section) {
        const titles = section.querySelectorAll('.ps-item-title');
        if (!titles.length) {return;}

        let maxHeight = 0;

        // reset
        titles.forEach(el => el.style.minHeight = '');

        // find max
        titles.forEach(el => {
            const h = el.offsetHeight;
            if (h > maxHeight) {
                maxHeight = h;
            }
        });

        // apply
        if (maxHeight) {
            titles.forEach(el => {
                el.style.minHeight = maxHeight + 'px';
            });
        }
    }

    document.querySelectorAll('.products-slider').forEach((section) => {
        const sliderContainer = section.querySelector('.ps-slider');
        if (!sliderContainer) {return;}

        const swiper = new Swiper(sliderContainer, {
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 20,
            loop: false,
            speed: 800,

            pagination: {
                el: section.querySelector('.ps-pagination'),
                clickable: true,
            },

            breakpoints: {
                660: {
                    slidesPerView: 2,
                    spaceBetween: 16,
                },
                767: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                },
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 20,
                },
                1200: {
                    slidesPerView: 3,
                    spaceBetween: 50,
                },
            },

            // 🔥 IMPORTANT EVENTS
            on: {
                init: function() {
                    setPsTitleHeight(section);
                },
                resize: function() {
                    setPsTitleHeight(section);
                },
                slideChange: function() {
                    setPsTitleHeight(section);
                },
            },
        });

        // fallback (just in case)
        window.addEventListener('load', () => setPsTitleHeight(section));
    });
});